import { render, staticRenderFns } from "./TheMenuSubmenu.vue?vue&type=template&id=68b4f9ac&"
import script from "./TheMenuSubmenu.vue?vue&type=script&lang=js&"
export * from "./TheMenuSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b4f9ac')) {
      api.createRecord('68b4f9ac', component.options)
    } else {
      api.reload('68b4f9ac', component.options)
    }
    module.hot.accept("./TheMenuSubmenu.vue?vue&type=template&id=68b4f9ac&", function () {
      api.rerender('68b4f9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheMenuSubmenu.vue"
export default component.exports